import React, { useRef, useState } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { Dropdown } from 'components/components/atoms';
import { searchProductTypes } from 'utils/enums';
import useBreakpoint from 'utils/hooks/useBreakpoint';

const Container = styled.div`
  ${({ isMobile }) => (isMobile ? 'width: 100%;' : 'width: 10.625rem;')}
`;
const ListContainer = styled.div`
  ${({ isMobile }) => (isMobile ? 'max-height: 25rem;' : 'max-height: 27rem;')}
`;
const CommunityList = styled.div`
  display: inline-grid;
  column-gap: 5rem;
`;
const Button = styled.button`
  margin-bottom: 0.5rem;
  &:nth-last-child(1) {
    margin-bottom: 0rem;
  }
`;

const CommunityDropdown = (props) => {
  const {
    selectedCommunity = [],
    onCommunityChange,
    communitiesFilter = [],
    selectedProductType,
    onPrimaryFilterChange,
    active: activeProp,
    setActive: setActiveProp,
    dropdownDescription = '',
    isSeachFilter = false,
    nCommunity,
    withSelectClick = true,
  } = props;

  const ref = useRef();
  const [activeState, setActiveState] = useState(false);

  const active = activeProp || activeState;
  const setActive = setActiveProp || setActiveState;

  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);

  const handleSelectFilter = () => {
    onPrimaryFilterChange(searchProductTypes.COMMUNITY);
  };
  const communitiesList = communitiesFilter.sort((a, b) =>
    a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1,
  );

  const getTitle = (type) => {
    let dPTitle = '';
    if (selectedCommunity && selectedCommunity.length === 1) {
      if (type === 1) {
        dPTitle = 'All Communities';
      } else {
        dPTitle = (
          <>
            Communities <span className='ml-2'>{nCommunity || 0}</span>
          </>
        );
      }
    } else {
      for (let c = 1; c < selectedCommunity.length; c++) {
        dPTitle += `${selectedCommunity[c].title}, `;
      }
      dPTitle = dPTitle.slice(0, -2);
    }

    return dPTitle;
  };

  const dropdownTitle = getTitle(1);

  return (
    <Container
      isMobile={isMobile}
      onBlur={() => {
        setTimeout(() => {
          if (ref && ref.current) {
            const containsFocusedElement = ref.current.contains(
              document.activeElement,
            );
            if (!containsFocusedElement) {
              setActive(false);
            }
          }
        }, 100);
      }}
      ref={ref}
    >
      <Dropdown
        label={
          communitiesList.length !== 0 ? (
            getTitle(2)
          ) : (
            <>
              Communities{' '}
              <span className='ml-2'>{communitiesList.length || 0}</span>
            </>
          )
        }
        active={active}
        setActive={setActive}
        activeFilter={selectedProductType === searchProductTypes.COMMUNITY}
        onSelectFilterClick={handleSelectFilter}
        style={!isMobile ? { maxWidth: '10.625rem' } : undefined}
        withSelectClick={withSelectClick}
        dropdownName={'Communities'}
        dropdownDescription={
          dropdownDescription
            ? dropdownTitle + '. ' + dropdownDescription
            : 'Community selector'
        }
        ariaPressed={selectedProductType === searchProductTypes.COMMUNITY}
        textLightBlue
      >
        <ListContainer
          className='overflow-y-auto lg:flex w-full md:w-auto pl-2 pr-10'
          isMobile={isMobile}
          aria-live='polite'
        >
          <CommunityList>
            <Button
              role={'checkbox'}
              type='checkbox'
              className='relative flex items-center tracking-normal text-sm whitespace-nowrap'
              key={'All'}
              onClick={(e) => {
                onCommunityChange({ id: null, title: 'All' });
                console.log(selectedCommunity);
              }}
              aria-checked={selectedCommunity.length === 1}
            >
              <div
                className={cx('w-4 h-4 mr-2 rounded-full', {
                  'bg-white': selectedCommunity.length === 1,
                  'border-2 border-white': selectedCommunity.length !== 1,
                })}
              ></div>
              <span>All</span>
            </Button>
            {communitiesList.map((community, index) => (
              <Button
                type='checkbox'
                role={'checkbox'}
                className='relative flex items-center tracking-normal text-sm whitespace-nowrap'
                key={community.id}
                onClick={(e) => {
                  onCommunityChange(community);
                }}
                aria-checked={selectedCommunity.find((sC) => {
                  return sC.id === community.id;
                })}
                aria-label={community.title + ' community'}
              >
                <div
                  className={cx('w-4 h-4 mr-2 rounded-full', {
                    'bg-white': selectedCommunity.find((sC) => {
                      return sC.id === community.id;
                    }),
                    'border-2 border-white': selectedCommunity.find((sC) => {
                      return sC.id !== community.id;
                    }),
                  })}
                ></div>
                <span>
                  {community.title.length > 40
                    ? community.title.substring(0, 37) + '...'
                    : community.title}
                </span>{' '}
              </Button>
            ))}
          </CommunityList>
        </ListContainer>
      </Dropdown>
    </Container>
  );
};

export default CommunityDropdown;
